// Load plugins
import TomSelect from "tom-select";

// Attach to the window object
window.TomSelect = TomSelect;

// Información referente al tom-select:
// tom-select con livewire: https://gist.github.com/mithicher/9944232624cbad4b1cb5d3d2cac87a97
// tom-select: https://tom-select.js.org/examples/options/

(function () {
    "use strict";

    // Tom Select
    $(".tom-select").each(function () {
        let options = {
            plugins: {
                dropdown_input: {},
            },
        };

        if ($(this).data("placeholder")) {
            options.placeholder = $(this).data("placeholder");
        }

        if ($(this).attr("multiple") !== undefined) {
            options = {
                ...options,
                plugins: {
                    ...options.plugins,
                    remove_button: {
                        title: "Borrar esta opción",
                    },
                },
                persist: false,
                create: false,
                onDelete: function (values) {
                    return confirm(
                        values.length > 1
                            ? "Estás seguro de remover estas " +
                                  values.length +
                                  " opciones?"
                            : 'Estás seguro de remover la opción "' +
                                  values[0] +
                                  '"?'
                    );
                },
            };
        }

        if ($(this).data("header")) {
            options = {
                ...options,
                plugins: {
                    ...options.plugins,
                    dropdown_header: {
                        title: $(this).data("header"),
                    },
                },
            };
        }

        new TomSelect(this, options);
    });
})();
